import { z } from "zod";

export const TaskGroupSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    systemKey: z.string().nullable(),
    workspaceId: z.string().uuid().nullable(),
    organizationId: z.string().uuid().nullable(),
    createdByUserId: z.number().nullable(),
    createdAt: z.coerce.date(),
    updatedByUserId: z.number().nullable(),
    updatedAt: z.coerce.date(),
});

export type TaskGroup = z.infer<typeof TaskGroupSchema>;

export const TaskGroupTaskCountSchema = z.object({
    taskGroupId: z.string().uuid(),
    count: z.number(),
});

export type TaskGroupTaskCount = z.infer<typeof TaskGroupTaskCountSchema>;
